import React from "react";
import type { DraftView } from "@/api";
import { Button } from "@/ds";
import { Icon } from "@/lib";
import { useT } from "../../i18n";
import { SignaturePreview } from "./signature-preview";
import { OutboundAttachments } from "./outbound-attachments";
import styles from "./email-review.module.css";

export function DraftTools({ draft, editing, onChanged, onOpenDetails }: {
  draft: DraftView; editing: boolean; onChanged?: () => Promise<void> | void; onOpenDetails?: () => void;
}) {
  const t = useT(), id = React.useId();
  const [signatureOpen, setSignatureOpen] = React.useState(false);
  return <OutboundAttachments draft={draft} editing={editing} onChanged={onChanged} tools={{
    before: draft.signature && <Button variant="ghost" aria-expanded={signatureOpen} aria-controls={id}
      iconLeft={<Icon name={signatureOpen ? "chevronDown" : "chevronRight"} size={18} />}
      onClick={() => setSignatureOpen(!signatureOpen)}>{t("ws.draftTools.signature")}</Button>,
    after: onOpenDetails && <Button variant="ghost" onClick={onOpenDetails}
      iconLeft={<Icon name="fileText" size={18} />} iconRight={<Icon name="chevronRight" size={18} />}>
      {t("ws.draftTools.basis")}
    </Button>,
    expanded: draft.signature && <div id={id} hidden={!signatureOpen} className={styles.draftSignature}>
      <SignaturePreview signature={draft.signature} />
    </div>,
  }} />;
}
